import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sellers-page',
  templateUrl: './sellers-page.component.html',
  styleUrls: ['./sellers-page.component.less']
})
export class SellersPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
